/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useGame } from "../../data/gameContext";
import { THighScore } from "../../data/highScore";
import { AreSameLocation } from "../map/mapGenerator";

export default function GameOver() {
    const { gameState, getGameTime } = useGame(); 
    const caughtString = `You were caught by ${gameState.GameOver.endedBy} in the town of ${gameState.GameTowns.find(t => AreSameLocation(t.Location, gameState.PlayerCharacter?.Location))?.Name || "Unknown"}`;

    useEffect(() => {
        // we need to save the player score here
        let highScores: THighScore[] = JSON.parse(localStorage.getItem("highScores") || "[]");
        let newScore: THighScore = { 
            character: gameState.PlayerCharacter?.Name ?? "Unknown",
            score: gameState.GameTime, // for now this is the score.
            datePlayed: new Date().toISOString(),
            gameDate: getGameTime(),
            howGameEnded: caughtString // for now this is the only way to end a game
        }
        highScores.push(newScore);
        highScores.sort((a, b) => b.score - a.score);
        // check for any duplicate records, and remove one of them if there are any
        for (let i = 0; i < highScores.length - 1; i++) {
            if (highScores[i].score === highScores[i + 1].score) {
                highScores.splice(i, 1);
                break;
            }
        }
        highScores = highScores.slice(0, 100); // keep only the top 100 scores
        localStorage.setItem("highScores", JSON.stringify(highScores));

    }, []);
    

    return (
        <div>
            <h1>Game Over</h1>
            <h3>{caughtString}</h3>
            <p>You are bound to a cart and taken to the depths of the theme park, where you face dismantling for spare parts, with everyone believing you were responsible for a guest's demise.</p>
            <p>Meanwhile, The Wild Bunch remain at large, their next move shrouded in uncertainty.</p>
            <button onClick={() => (window.location.href = "/")}>Exit Game</button>
        </div>
    )
}   